import { Button, Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { AccessControl } from '../../../AccessControl/AccessControl';
import { AccessDeniedButton } from '../../../../styles/AccessDenied.styles';
import React from 'react';

export type CreateButtonProps = {
  title: string;
  onClick: () => void;
  permission: string;
  disabled?: boolean;
};

export type CreateButtonComponent = React.FC<CreateButtonProps>;

export const CreateButton: CreateButtonComponent = ({ title, onClick, permission, disabled }) => {
  return (
    <AccessControl
      permission={permission}
      renderIfNoAccess={
        <Tooltip
          title={
            <Flexbox container direction="column">
              <Typography variant="caption" color={() => 'white'}>
                You do not have permissions to perform this action.
              </Typography>
              <Typography variant="caption" color={() => 'white'}>
                Required permissions: {/*@ts-ignore*/}
                <Typography variant="caption" weight="bold" color={() => 'white'}>
                  {permission}
                </Typography>
              </Typography>
            </Flexbox>
          }
        >
          <AccessDeniedButton disabled variant="secondary" data-testid="create-entity-button">
            <Flexbox container alignItems="center" gutter={2}>
              <Flexbox item container alignItems="center">
                <Icon.Plus size="sm" color={() => '#757575'} />
              </Flexbox>
              <Flexbox item container alignItems="center">
                <Typography variant="body2">{title}</Typography>
              </Flexbox>
            </Flexbox>
          </AccessDeniedButton>
        </Tooltip>
      }
    >
      <Button variant="secondary" data-testid="create-entity-button" onClick={onClick} disabled={disabled}>
        <Flexbox container alignItems="center" gutter={2}>
          <Flexbox item container alignItems="center">
            <Icon.Plus size="sm" />
          </Flexbox>
          <Flexbox item container alignItems="center">
            <Typography variant="body2">{title}</Typography>
          </Flexbox>
        </Flexbox>
      </Button>
    </AccessControl>
  );
};
